<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <path d="M18.4,5.6H5.6v9.6h11.864l0.936,0.936V5.6z M20,5.6V20l-3.2-3.2H5.6c-0.884,0-1.6-0.716-1.6-1.6l0,0V5.6 C4,4.716,4.716,4,5.6,4h12.8C19.284,4,20,4.716,20,5.6L20,5.6z" />
</svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'comment'
}
</script>
